import {AdminService} from '../shared/service/admin/admin.service';
import {ErrorhandleService} from './service/errorhandle.service';
import {Component, OnInit, ViewEncapsulation, AfterContentInit, AfterViewInit, ViewChild} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import { Subscription, Subject, Observable } from 'rxjs/Rx';
import * as $ from 'jquery';
import { AlertComponent } from './alert/alert.component';
import { Alert, AlertType } from 'app/model/shared/alert';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AdminComponent implements OnInit, AfterViewInit {

  @ViewChild(AlertComponent)
  alertComponent: AlertComponent;

  time = new Date();
  _loginStatus: Subject<boolean>;
  _isLogin: Boolean = this.adminService._isLogin;
  constructor(private _router: Router,
    private errorHandle: ErrorhandleService,
    private adminService: AdminService) {
    this._loginStatus = adminService._loginSubscription;
    this._loginStatus.subscribe((value) => {this._isLogin = value});

    $(window).resize(function() {
      // const bodyHeight = $('body').prop('scrollHeight');
      // const containerHeight = $('#admin-content-container').prop('scrollHeight');
      // const containerWidth = $('#admin-content-container').prop('scrollHeight');
      // const topMenuHeight = $('#admin-menu-top-container').prop('scrollHeight');
      // const applyHeight = containerHeight;
      // $('#admin-menu-left-container').height(applyHeight + topMenuHeight);
      // $('.popup-wrap').height(applyHeight + topMenuHeight);
      $('#admin-menu-left-container').height($('html, body').prop('scrollHeight'));
      $('.popup-wrap').height($('html, body').prop('scrollHeight'));
    });

    // setInterval(this.setTime.bind(this), 300);

    $(document).ready(
      function() {
        const target = $('#admin-wrap')[0];
        // create an observer instance
        const observer = new MutationObserver(function(mutations) {
          // const bodyHeight = $('body').prop('scrollHeight');
          // const containerHeight = $('#admin-content-container').prop('scrollHeight');
          // const topMenuHeight = $('#admin-menu-top-container').prop('scrollHeight');
          // const applyHeight = containerHeight;
          // $('#admin-menu-left-container').height(applyHeight + topMenuHeight);
          // $('.popup-wrap').height(applyHeight + topMenuHeight);
          $('#admin-menu-left-container').height($('html, body').prop('scrollHeight'));
          $('.popup-wrap').height($('html, body').prop('scrollHeight'));
        });

        // configuration of the observer:
        const config = {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true
        };

        // passing the target node and the observer options
        observer.observe(target, config);
      }
    );

    _router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(function() {
          // const bodyHeight = $('body').prop('scrollHeight');
          // const containerHeight = $('#admin-content-container').prop('scrollHeight');
          // const containerWidth = $('#admin-content-container').prop('scrollHeight');
          // const topMenuHeight = $('#admin-menu-top-container').prop('scrollHeight');
          // const applyHeight = containerHeight;
          // $('#admin-menu-left-container').height(applyHeight + topMenuHeight);
          // $('.popup-wrap').height(applyHeight + topMenuHeight);
          $('#admin-menu-left-container').height($('html, body').prop('scrollHeight'));
          $('.popup-wrap').height($('html, body').prop('scrollHeight'));
        }, 100);
      }
    });
  }

  setTime() {

  }

  ngOnInit() {
    if (!this._isLogin) {
      this._router.navigate(['/admin__/login'], {replaceUrl: true});
    } else {
      this._router.navigate(['/admin__/home']);
    }
  }
  ngAfterViewInit(): void {
    const target = $('#tab-holder')[0];
    const separatorHeight = 2;
    // create an observer instance
    const observer = new MutationObserver(function(mutations) {

      const tabs = $(target).children();
      const separators = tabs.toArray().filter(val => $(val).height() === separatorHeight);
      let skip = 0 || separators.length;
      tabs.each((idx, val) => {
        if ($(val).height() === separatorHeight) {
          skip--;
          return;
        }
        const holderHeight = $(target).height();
        const prev = tabs[idx - 1];
        const isSeparator = ($(val).height() === separatorHeight);

        if (separators.length > 0) {
          separators.forEach((_val, _idx, _arr) => {
            if (!$(_val).next().length) {
              $(_val).remove();
            }
          });
        }

        if (prev && skip <= 0) {
          if (Math.abs(val.offsetTop - prev.offsetTop) > 10) {
            $('<div style="height : ' + separatorHeight + 'px; background : #d8dbe0;"></div>').insertBefore(val);
          }
        }
      });
    });

    // configuration of the observer:
    const config = {
      childList: true,
      subtree: true,
    };

    // passing the target node and the observer options
    observer.observe(target, config);
  }

  alertErrorCode (message, errorcode) {
    const alert: Alert = new Alert(AlertType.Alert, false);
    alert.ErrorCode = errorcode;
    alert.message = message;
    this.alertResponse(alert);
  }

  alert (message: string) {
    const alert: Alert = new Alert(AlertType.Alert, false);
    alert.message = message;
    this.alertResponse(alert);
  }

  alertDetail (message: string, emphasis: boolean) {
    const alert: Alert = new Alert(AlertType.Alert, emphasis);
    alert.message = message;
    this.alertResponse(alert);
  }

  alertResponse (data) {
    const alert: Alert = data;
    alert.type = AlertType.Alert;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
  }

  alertCallback (message: string, callback: () => void) {
    const alert: Alert = new Alert(AlertType.Alert, false);
    alert.message = message;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
    this.alertComponent.confirm(this);
    this.setConfirmation(message, callback);
  }

  private subject = new Subject<any>();
  confirm(message: string, callback: (result: boolean) => void) {
    const alert: Alert = new Alert(AlertType.Confirm, false);
    alert.message = message;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
    this.alertComponent.confirm(this);
    this.setConfirmation(message, callback);
  }

  confirmDetail(message: string, emphasis: boolean, callback: (result: boolean) => void) {
    const alert: Alert = new Alert(AlertType.Confirm, emphasis);
    alert.message = message;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
    this.alertComponent.confirm(this);
    this.setConfirmation(message, callback);
  }
  
  private setConfirmation(message: string, callback: (result: boolean) => void) {
    let that = this;
    this.subject.next({
      type: "confirm",
      text: message,
      yesFn:
        function () {
          that.subject.next(); //this will close the modal
          callback(true);
        },
      noFn: 
        function () {
          that.subject.next();
          callback(false);
        }
    });
  }

  getContainer(): Observable<any> {
    return this.subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts